<template>
	<div>
		<div class="row">
			<div class="col-md-6 col-12 mt-2">
				<h3>Virtual Stock based on Expedition</h3>
				<!-- <h6>Choose 1 Dealer To Use This Feature</h6> -->
			</div>
			<!-- <div class="col-md-3 col-6 mt-2 wrapHighlight">
				<Multiselect
					:options="filterData.dealer.map((x) => x.code)"
					:custom-label="
						(opt) =>
							filterData.dealer.find((x) => x.code == opt).name
					"
					placeholder="Select 1 Dealer"
					:allow-empty="false"
					v-model="filter.dealer"
				/>
			</div> -->
			<div class="col-md-2 col-3 mt-2">
				<Multiselect
					:options="filterData.transporter.filter(x => x)"
					v-model="filter.transporter"
					placeholder="All Transporter"
				/>

				<!-- {{filterData.transporter}} -->
			</div>
			<div class="col-md-2 col-3 mt-2">
				<!-- <Multiselect
					:options="filterData.trendType"
					:allow-empty="false"
					v-model="showType"
				/> -->
				<input 
					type="text" 
					class="form-control" 
					style="height:40px;" 
					placeholder="All License Plate" 
					@input="debounceInput"
				/>
			</div>
			<div class="col-md-2 col-3 mt-2">
				<button
					class="btn w-100 btn-secondary"
					style="height:40px"
					@click="downloadExcel"
				>
					Download CSV
				</button>
			</div>
		</div>

		<div class="mt-3" v-if="dataTable">
			<!-- {{dataTable}} -->

			<table class="table text-center">
				<thead>
					<th>License Plate</th>
					<th>Transporter</th>
					<th>Virtual</th>
				</thead>
				<tbody v-if="dataTable.length > 0">
					<tr v-for="data in dataTable">
						<td>{{data.license_plate}}</td>
						<td>{{data.transporter}}</td>
						<td>{{data.virtual_stock}}</td>
					</tr>
				</tbody>
				<tbody>
					<tr>
						<td colspan="3">
							<b>No Result</b>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
import Multiselect from "vue-multiselect";
// import TrendSalesLineChart from "./children/TrendSalesLineChart.vue";
import XLSX from "xlsx";
import moment from "moment";
import debounce from 'debounce'

export default {
	components: {
		Multiselect,
		// TrendSalesLineChart,
	},
	data() {
		return {
			filter: {
				transporter : null,
				plate_no : null
			},
			dataTable: null,
			formattedData: null,
			filterData: {
				transporter : this.$store.getters.getFilterOptions.transporter
				// trendType: ["by Table", "by Line Chart"],
				// dealer: this.$store.getters.getDealer(null, null),
			},
			salesRef: null,
		};
	},
	watch: {
		"filter.transporter": function() {
			this.loadApi();
		},
		"filter.plate_no" : function () {
			// alert(this.filter.plate_no)
			this.loadApi();
		}
	},
	mounted() {
		this.loadApi();
	},
	methods: {
		debounceInput : debounce(function (e) {
			this.filter.plate_no = e.target.value
		} , 1000),
		downloadExcel() {
			// var wb = XLSX.utils.table_to_book(document.getElementById('table'), {sheet:"Data"});

			// let keys = Object.keys(this.formattedData[0]);

			// let arrRing = ["LOKASI", "OTHER", "RING 1", "RING 2", "RING 3"];
			// // let data = new Array(arrRing.length).fill({})
			// let data = [
			// 	{
			// 		Ring: arrRing[0],
			// 	},
			// 	{
			// 		Ring: arrRing[1],
			// 	},
			// 	{
			// 		Ring: arrRing[2],
			// 	},
			// 	{
			// 		Ring: arrRing[3],
			// 	},
			// 	{
			// 		Ring: arrRing[4],
			// 	},
			// ];
			// for (var j = 0; j < this.formattedData.length; j++) {
			// 	for (var i = 0; i < data.length; i++) {
			// 		let changePercentage = parseFloat(
			// 			this.formattedData[j][data[i]["Ring"] + "Percentage"]
			// 		);
			// 		data[i][
			// 			this.formattedData[j].bulan + " - Sales"
			// 		] = this.formattedData[j][data[i]["Ring"] + "Sales"];
			// 		data[i][this.formattedData[j].bulan + " - Change %"] =
			// 			changePercentage > 0
			// 				? "+ " + changePercentage
			// 				: changePercentage;
			// 	}
			// }
			if(this.dataTable.length <= 0) {
				alert('No Result. Unable to generate Excel File')
			}

			let wb = XLSX.utils.book_new();
			let ws1 = XLSX.utils.json_to_sheet(this.dataTable, { raw: true });
			XLSX.utils.book_append_sheet(wb, ws1, "Virtual Stock Based On Expedition");

			XLSX.writeFile(wb, "Virtual Stock Expedition.xlsx");
		},
		async loadApi() {
			try {
				this.dataTable = null;

				let url = '/api/reports/virtual-stock-expedition?'
				url = this.initialiseFilter(url , this.filter)

				let resp = await this.$http.get(url)

				this.dataTable = resp.data.data
			}
			catch(err) {
				console.log(err)
			}
			

		},
		// calculateTotal(data) {
		// 	this.salesRef = [];
		// 	for (var i = 0; i < data.length; i++) {
		// 		let curData = data[i];
		// 		let keys = Object.keys(curData);

		// 		let total = {
		// 			sales: 0,
		// 			percent: 0,
		// 			growth: 0,
		// 		};

		// 		for (var j = 0; j < keys.length; j++) {
		// 			let curKeys = keys[j];
		// 			if (curKeys == "bulan") continue;

		// 			total.sales += curData[curKeys].sales;
		// 			total.percent += parseFloat(curData[curKeys].percent);
		// 			total.growth += parseFloat(curData[curKeys].growth);
		// 		}

		// 		this.salesRef.push(total);
		// 	}
		// },
	},
};
</script>

<style scoped>
.text-red {
	color: red;
}
.text-green {
	color: green;
}
td {
	height:50px;
	width:100px;
}

.freezeCol  {
	position:absolute; 
	width:101px;
 
	height:50px;

	background-color: white;
	margin-top:-1.5px;
	margin-left:-1px;
	/* top:auto; */
	/* border-right: 0px none black;  */
	/* border-top-width:3px; only relevant for first row */
	/* margin-top:-3px; compensate for top border */
}
</style>
